exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-81d52bfc] .bui-drawer-body{padding:0 !important}\n", ""]);

